export default value => value.toString().replace('.', ',')
